(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatientDetailController', PatientDetailController);

    PatientDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'Patient', 'ProspectivePatient'];

    function PatientDetailController($scope, $rootScope, $stateParams, DataUtils, entity, Patient, ProspectivePatient) {
        var vm = this;
        vm.patient = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:patientUpdate', function(event, result) {
            vm.patient = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
    }
})();
